export const budgetCheckAmountTypeName = 'budgetCheckAmountType';
